package ir.site.zero1plus.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.components.BSToastBasic
import com.stevdza.san.kotlinbs.components.BSToastGroup
import com.stevdza.san.kotlinbs.models.ToastStyle
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.core.Page
import ir.site.zero1plus.components.layouts.PageLayout
import ir.site.zero1plus.components.sections.AboutMeSection
import ir.site.zero1plus.components.sections.ContactMeSection
import ir.site.zero1plus.components.sections.HeroSection
import ir.site.zero1plus.components.sections.LicenseSection
import ir.site.zero1plus.components.widgets.OverFlowMenu
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Page
@Composable
fun HomePage() {

    var menuOpen by remember { mutableStateOf(false) }

    PageLayout(
        title = "zero 1 plus | official",
        description = "hello this page is sponsored by mohammad hossein mazloom zadeh , the creator !",
        onOverFlowMenuClicked = {
            menuOpen = true
        }
    ) {

        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(20.px)
        ) {
            HeroSection()
            AboutMeSection()
            LicenseSection()
            ContactMeSection()
        }

        if (menuOpen) {
            OverFlowMenu(
                onMenuClosed = {
                    menuOpen = false
                }
            )
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .position(Position.Fixed)
                .pointerEvents(PointerEvents.None)
        ) {
            BSToastGroup {
                BSToastBasic(
                    id = "emailSubmitSuccess",
                    text = "پیامتان با موفقیت ایمیل شد.",
                    style = ToastStyle.Success,
                    autoHide = true,
                    closeButtonDark = false,
                    onCloseClick = {}
                )
            }
        }


    }

}
